import userEvent from '@testing-library/user-event';
import Axios from 'axios';
import React, { useState, createContext, useContext, useEffect } from 'react';
import StateManager from 'react-select';

import { apiUrl, apiSocket } from '../config';
import { useAuth } from './Auth';

interface IPagesContextData {
  menu: Array<Record<string, any>>;
}

interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: string;
  external: string;
  status: string;
  statusLogged: string;
  className: string;
}

interface ICompiledMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
  className: string;
}

const PagesContext = createContext<IPagesContextData>({} as IPagesContextData);

const PagesProvider: React.FC = ({ children }) => {
  const {user} = useAuth();
  const [menuReference,setMenuReference] = useState<Array<IMenu>>([]);
  const load = async () => {

    const menuData = await Axios.get('/config/menu.json');
    const {data} = menuData;

    setMenuReference(data || {});
  }

  useEffect(() => {
    load()
  },[])

  const printLine = (line : IMenu) : ICompiledMenu => {

    const elem : ICompiledMenu = {
      title: line?.title,
      target: line?.target,
      targetID: line?.targetID,
      fluid: line?.fluid === "2" ? 2 : 1,
      external: line?.external === "2" ? 2 : 1,
      status: line?.status && line?.status === "2" ? 2 : user && line?.statusLogged === "2" ? 2 : 1,
      className : line?.className || ''
    };

    return elem;
  }

  const [menu, setMenu] = useState<Array<ICompiledMenu>>([]);



  useEffect(() => {

    const menuItems : Array<ICompiledMenu> = [];

    menuReference.map( item => {
      menuItems.push(printLine(item));
    })


    if(user &&  (user?.profile === 1 || user?.profile === 4)){
      menuItems.push({
        title: 'GERENCIADOR',
        target: '/manager',
        targetID: '',
        fluid: 1,
        external: 1,
        status: 2,
        className: ''
      })
    }

    setMenu(menuItems);

  },[menuReference, user])

  return (
    <PagesContext.Provider value={{ menu }}>
      {children}
    </PagesContext.Provider>
  );
};

function usePages(): IPagesContextData {
  const context = useContext(PagesContext);

  if (!context) {
    throw new Error('usePages must be used within a PagesProvider');
  }

  return context;
}

export { usePages, PagesProvider };
